import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StartupComponent } from './startup/startup.component';
import { RouterModule } from '@angular/router';
import { MainMapModule } from './main-map/main-map.module';
import { DetailViewModule } from './detail-view/detail-view.module';
import { HeaderPanelModule } from './header-panel/header-panel.module';
import { ToolsModule } from './tools/tools.module';
import {SharedModule} from '../shared/shared.module';

export const COMPONENTS = [StartupComponent];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    MainMapModule,
    HeaderPanelModule,
    DetailViewModule,
    ToolsModule,
    SharedModule,
  ],
  exports: [COMPONENTS, MainMapModule, DetailViewModule, HeaderPanelModule, ToolsModule],
})
export class ComponentModule {}
